import * as React from 'react';
import { UseTranslationResponse } from 'react-i18next';

// At some point fix this
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TranslationKey = any;

export type T = UseTranslationResponse<TranslationKey, string>['t'];

// Define Context to expect the t function
const Context = React.createContext<{ t: T } | undefined>(undefined);

function TranslationsProvider({
    children,
    t,
}: React.PropsWithChildren<{ t: T }>) {
    return <Context.Provider value={{ t }}>{children}</Context.Provider>;
}

function useTranslationsContext() {
    const context = React.useContext(Context);
    if (context === undefined) {
        throw new Error(
            'useTranslationsContext must be used within a TranslationsProvider',
        );
    }
    return context;
}

export { TranslationsProvider, useTranslationsContext };
